import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AdminPageData} from "./admin-dashboard/admin-datatable/admin-page-data";
import {AdminDashboardList} from "./admin-dashboard/admin-datatable/admin-dashboardList";
import {AdminPage} from "./admin-dashboard/admin-datatable/admin-page";
/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class AdminDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    adminDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: AdminPage,listData): Observable<AdminPageData<AdminDashboardList>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: AdminPage): AdminPageData<AdminDashboardList> {
        let pageData = new AdminPageData<AdminDashboardList>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new AdminDashboardList(jsonObj['id'], jsonObj['Name'], jsonObj['roleName'], jsonObj['email'],
                        jsonObj['emailVerified'], jsonObj['businessUnits'], jsonObj['pendingSubUserCount'], jsonObj['userId_WPASS'],
                        jsonObj['languageId'], jsonObj['languageName'], jsonObj['countryId'], jsonObj['countryName'], jsonObj['companyName'],
                        jsonObj['companyAddress'], jsonObj['companyPhone'], jsonObj['personalArea'], jsonObj['costCenter'], jsonObj['location'],
                        jsonObj['contractorType'], jsonObj['actionFlag'], jsonObj['status'], jsonObj['appStatus'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/adminDashboardResultService.ts